import { TResolvedVersion } from '../types';
import { resolveFileUrl } from '.';

/**
 * Create a preload link element
 * @param preloadId
 * @param version
 * @param baseUrl
 * @param file
 */
export const createPreloadLinkElement = (preloadId: string, version: TResolvedVersion, baseUrl: string, file?: string): HTMLElementTagNameMap['link'] => {
    const preload = document.createElement('link');

    preload.id = preloadId;
    preload.rel = 'preload';
    preload.as = 'script';
    preload.href = resolveFileUrl(baseUrl, version, file);

    return preload;
};
